import styled from "styled-components";
import { motion } from "framer-motion";
import { MobileUiVars } from "../ui-vars";
import appShellUiVars from "_c/AppShell/ui-vars";

export const Wrap = motion(styled.div`
  position: fixed;
  top: calc(${appShellUiVars.headMobileHeight} - 1px);
  left: 0;
  height: ${MobileUiVars.bottomBarHeight}px;
  width: 100%;
  background-color: var(--bg-paper);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
`);
export const Item = styled.div.attrs({
  role: "button",
  className: "ripple-btn",
})`
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 0 10px;
`;
export const Title = styled.span`
  position: relative;
  margin-top: 5px;
  font-size: 13px;
  color: var(--font-color-accent);
  font-weight: 500;
  ::before {
    content: "";
    display: ${({ hasBadge }) => (hasBadge ? "block" : "none")};
    position: absolute;
    right: -5px;
    bottom: 8px;
    width: 7px;
    height: 7px;
    background-color: var(--color-cta);
    border-radius: 50%;
  }
`;
export const IconWrap = styled.div`
  height: 18px;
  font-size: 18px;
`;
